import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getPushNotificationScheduleSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getNewsPushNotificationSchedule, params)
    yield put(actions.getPushNotificationScheduleSuccess(response?.data?.data))
    yield put(actions.getPushNotificationScheduleFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getPushNotificationScheduleFinish())
  }
}

function* addPushNotificationScheduleSaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addPushNotificationSchedule, body)
    yield put(actions.addPushNotificationScheduleSuccess(response.data?.data))
    yield delay(100)
    yield put(actions.addPushNotificationScheduleFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addPushNotificationScheduleFinish())
  }
}

function* updatePushNotificationScheduleSaga(action: ActionModel) {
  try {
    const body: any = action.payload.data
    const response: ResponseModel = yield call(
      service.updatePushNotificationSchedule,
      body,
      action.payload?.id
    )
    yield put(actions.updateNewsSuccess(response.data?.data))
    yield put(actions.updateNewsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateNewsFinish())
  }
}

function* deletePushNotificationScheduleSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deletePushNotificationSchedule, body)
    yield put(actions.deletePushNotificationScheduleSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deletePushNotificationScheduleFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deletePushNotificationScheduleFinish())
  }
}

function* singleActivateNews(action: ActionModel) {
  try {
    const selectedOperationIncharge: any = action.payload
    const response: ResponseModel = yield call(
      service.singleActivateNews,
      selectedOperationIncharge
    )
    yield put({
      type: actionTypes.SINGLE_ACTIVATE_NOTIFICATION_SUCCESS,
      payload: response?.data?.data,
    })
    yield delay(100)
    yield put({type: actionTypes.SINGLE_ACTIVATE_NOTIFICATION_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SINGLE_ACTIVATE_NOTIFICATION_FINISH})
  }
}

function* singleDeactivateNews(action: ActionModel) {
  try {
    const selectedOperationIncharge: any = action.payload
    const response: ResponseModel = yield call(
      service.singleDeactivateNews,
      selectedOperationIncharge
    )

    yield put({
      type: actionTypes.SINGLE_DEACTIVATE_NOTIFICATION_SUCCESS,
      payload: response?.data?.data,
    })
    yield delay(100)
    yield put({type: actionTypes.SINGLE_DEACTIVATE_NOTIFICATION_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SINGLE_DEACTIVATE_NOTIFICATION_FINISH})
  }
}

export function* saga() {
  yield takeLatest(
    actionTypes.GET_PUSH_NOTIFICATION_SCHEDULE_START,
    getPushNotificationScheduleSaga
  )
  yield takeLatest(
    actionTypes.ADD_PUSH_NOTIFICATION_SCHEDULE_START,
    addPushNotificationScheduleSaga
  )
  yield takeLatest(
    actionTypes.UPDATE_PUSH_NOTIFICATION_SCHEDULE_START,
    updatePushNotificationScheduleSaga
  )
  yield takeLatest(
    actionTypes.DELETE_PUSH_NOTIFICATION_SCHEDULE_START,
    deletePushNotificationScheduleSaga
  )
  yield takeLatest(actionTypes.SINGLE_ACTIVATE_NOTIFICATION_REQUEST, singleActivateNews)
  yield takeLatest(actionTypes.SINGLE_DEACTIVATE_NOTIFICATION_REQUEST, singleDeactivateNews)
}
